import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const socialLinks = [
  {
    name: "Instagram",
    href: "https://www.instagram.com/sulhafa.pet?igsi=ZHY2eThlamswMncw",
    icon: "/icons/Social Media Logos/Instagram_Logo.png",
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/share/1DAsaasEGU/",
    icon: "/icons/Social Media Logos/Facebook_Logo.png",
  },
  {
    name: "Snapchat",
    href: "https://snapchat.com/t/7z4Ux595",
    icon: "/icons/Social Media Logos/Snapchat_Logo.png",
  },
  {
    name: "TikTok",
    href: "https://www.tiktok.com/@sulhafa.pet?_r=1&_t=ZS-99HomvdIr5z",
    icon: "/icons/Social Media Logos/tiktok_Logo.png",
  },
  {
    name: "X",
    href: "https://x.com/sulhafapet?s=11",
    icon: "/icons/Social Media Logos/X_Logo.png",
  },
];

const LandingFooter = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <footer className="landing-footer">
      <div className="landing-footer-inner">
        <div className="landing-footer-about">
          <p>{t("landingFooter.description")}</p>
        </div>
        <div className="landing-footer-links">
          <div className="landing-footer-col">
            <h4>{t("landingFooter.exploreSulhafa.title")}</h4>
            <button className="footer-link-btn" onClick={() => navigate("/sulhafa-connect")}>
              {t("landingFooter.exploreSulhafa.sulhafaConnect")}
            </button>
            <button className="footer-link-btn" onClick={() => navigate("/sulhafa-care")}>
              {t("landingFooter.exploreSulhafa.sulhafaCare")}
            </button>
            <button className="footer-link-btn" onClick={() => navigate("/sulhafa-care")}>
              {t("landingFooter.exploreSulhafa.sulhafaShop")}
            </button>
          </div>
          <div className="landing-footer-col">
            <h4>{t("landingFooter.support.title")}</h4>
            <button className="footer-link-btn" onClick={() => navigate("/privacy")}>
              {t("landingFooter.support.privacyPolicy")}
            </button>
            <button className="footer-link-btn" onClick={() => navigate("/terms")}>
              {t("landingFooter.support.termsConditions")}
            </button>
            <button className="footer-link-btn" onClick={() => navigate("/contact")}>
              {t("landingFooter.support.contactUs")}
            </button>
          </div>
        </div>
        <div className="landing-footer-subscribe">
          <h4>{t("landingFooter.stayConnected.title")}</h4>
          <p>{t("landingFooter.stayConnected.description")}</p>
          <div className="landing-subscribe-form">
            <input type="email" placeholder={t("landingFooter.stayConnected.emailPlaceholder")} />
            <button>{t("landingFooter.stayConnected.subscribe")}</button>
          </div>
        </div>
      </div>
      <div className="landing-footer-bottom">
        <div className="landing-footer-social">
          {socialLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={link.name}
              className="landing-footer-social-link"
            >
              <img src={link.icon} alt={link.name} />
            </a>
          ))}
        </div>
        <p className="landing-footer-powered">{t("landingFooter.exploreSulhafa.PoweredbyRubix")}</p>
        <img src="/Landing page assets/Sulhafa_Logo_White.png" alt="Sulhafa" className="landing-footer-logo" />
      </div>
    </footer>
  );
};

export default LandingFooter;
